import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private loading: Promise<HTMLIonLoadingElement> | null = null;
  private dismissRequested = false;

  constructor(
    public loadingController: LoadingController
  ) { }

  // This will show then autohide the loader
  showHideAutoLoader() {

    this.loadingController.create({
      message: 'This Loader Will Auto Hide in 2 Seconds',
      duration: 2000
    }).then((res) => {
      res.present();

      res.onDidDismiss().then((dis) => {
        console.log('Loading dismissed! after 2 Seconds', dis);
      });
    });

  }

  // Show the loader for infinite time
  async showLoader(msg?: string) {
    if (this.loading) {
      return;
    }
    this.dismissRequested = false;
    this.loading = this.loadingController.create({ message: msg ? msg : '' });
    const loading = await this.loading;

    if (this.dismissRequested) {
      this.loading = null;
      this.dismissRequested = false;
      return;
    }
    await loading.present();
  }

  // Hide the loader if already created, otherwise no-op
  async hideLoader() {
    if (!this.loading) {
      return;
    }
    this.dismissRequested = true;
    const pending = this.loading;
    const loading = await pending;
    this.loading = null;
    this.dismissRequested = false;

    try {
      await loading.dismiss();
    } catch (error) {
      console.log('error', error);
    }
  }


}
